import React from 'react'
import { translate } from 'react-i18next'
import { func, object } from 'prop-types'
import { withRouter } from 'react-router'
import { addNoIndexIfNotExists, removeNoIndexIfExists } from '../utilities/window'

class Page404 extends React.Component {
  componentDidMount () {
    addNoIndexIfNotExists()
  }

  componentWillUnmount () {
    removeNoIndexIfExists()
  }

  render () {
    let { t, history } = this.props
    return (
      <div className='layout__container home__container--padding'>
        <div className='centered--container'>
          <h2>{t('common:404:title')}</h2>
          <p />
          <p><a style={{ cursor: 'pointer' }} onClick={() => history.goBack()}>{t('common:404:link')}</a></p>
        </div>
      </div>
    )
  }
}

Page404.propTypes = {
  t: func,
  history: object
}

export const NotFoundPage = withRouter(translate()(Page404))



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.js